import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

function TreeNode(props) {
  const { node, depth } = props;
  const [open, setOpen] = useState(depth < 1);
  const kids = node.children || [];
  const nodeId = node.id || node.name;
  const children = open && kids.length > 0
    ? React.createElement(
        "ul",
        { className: "tree-children" },
        kids.map((child) =>
          React.createElement(TreeNode, {
            key: child.id || child.name,
            node: child,
            depth: depth + 1,
          })
        )
      )
    : null;
  return React.createElement(
    "li",
    { className: "tree-node depth-" + depth, "data-testid": "tree-node-" + nodeId },
    React.createElement(
      "div",
      { className: "tree-row" },
      kids.length > 0
        ? React.createElement(
            "button",
            {
              type: "button",
              className: "tree-toggle",
              onClick: () => setOpen(!open),
              "data-testid": "tree-toggle-" + nodeId,
            },
            open
              ? React.createElement(ChevronDown, { size: 14 })
              : React.createElement(ChevronRight, { size: 14 })
          )
        : React.createElement("span", { className: "tree-spacer" }),
      React.createElement(
        "div",
        { className: "tree-chip" },
        React.createElement("strong", null, node.name || "Member"),
        node.level
          ? React.createElement("small", null, "Level " + node.level)
          : React.createElement("small", null, "Root")
      )
    ),
    children
  );
}

export function ReferralTree({ root }) {
  if (!root) {
    return (
      <div className="empty-activity">
        <p>No referral activity yet.</p>
      </div>
    );
  }
  return (
    <ul className="tree-root" data-testid="referral-tree">
      {React.createElement(TreeNode, { node: root, depth: 0 })}
    </ul>
  );
}

export function buildTree(selfName, members) {
  const root = { id: "self", name: selfName || "You", level: 0, children: [] };
  const byId = { self: root };
  (members || []).forEach((m) => {
    byId[m.id] = { id: m.id, name: m.name, level: m.level, sponsor_id: m.sponsor_id, children: [] };
  });
  (members || []).forEach((m) => {
    const parent = m.level === 1 ? root : byId[m.sponsor_id];
    if (parent) parent.children.push(byId[m.id]);
  });
  return root;
}
